// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  basePath: '/',
  api: '/api',
  apiVersion: 'v1',
  imageBaseUrl: 'assets/images',
  documentsBaseUrl: 'assets/documents',
  stripeKey: 'pk_test_51Ljht7B4sOjIGwWRXryoUWThvBOgUyIaXQ2N3vqw7T6SywalJGieJas5pZbF4l4ztzxwd1G4JUfHzUhAsecnxBgw00JA650FEj',
  froalaApiKey: 'Ne2C1sF4D3H3B15B7C7jF1QUg1Xc2OZE1ABVJRDRNGGUH1ITrA1C7A6F6E1E4H4E1A9A8==',
  firebase: {
    apiKey: 'AIzaSyDpoEbaYl-QkFRnxIpoBFtIbQscfviHSkg',
    authDomain: 'accreditation-survey-app.firebaseapp.com',
    projectId: 'accreditation-survey-app',
    storageBucket: 'accreditation-survey-app.appspot.com',
    messagingSenderId: '347831945413',
    appId: '1:347831945413:web:dddbc2d1b07fedafb188ac',
    measurementId: 'G-V4W1QMS5PC'
  },
  recaptcha: {
    siteKey: '6LeIxAcTAAAAAJcZVRqyHh71UMIEGNQ_MXjiZKhI',
  },
  googleClientId: '988969774210-1olh1dmh00u015vbq99aqdcco2iag64h.apps.googleusercontent.com',
  version: 'dev-2.3.3'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
